import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import Util from "../common/util";

function PitchSlide(props) {
  const settings = {
    arrows: true,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1198.98,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767.98,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 575.98,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  const { pitch } = props;
  const user = pitch.user;

  return (
    <Slider {...settings}>
      <div className='pitch-card cover'>
        <div className='card-inner'>
          <h2>ABOUT SERVICE</h2>
          <div className='main-info'>
            <div>
              <div className='rounded-circle company-initial'>
                <span>{pitch.service_name.slice(0, 1)}</span>
              </div>
              <h3 className='service-name'>{pitch.service_name}</h3>
              {pitch.service_url && (
                <a href={pitch.service_url} target='_blank' rel='noopener noreferrer' className='service-url'>
                  {pitch.service_url}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className='pitch-card'>
        <div className='card-inner'>
          <div className='contents'>
            <h3>
              <i className='far fa-tag' />
              サービスのカテゴリ
            </h3>
            <p>
              {pitch.service_category}
            </p>
            <h3>
              <i className='far fa-code' />
              サービスの進捗状況
            </h3>
            <p>
              {pitch.service_progress}
            </p>
            <h3>
              <i className='far fa-calendar' />
              取り組んでいる期間
            </h3>
            <p>
              {pitch.service_development_term}
            </p>
          </div>
        </div>
      </div>

      <div className='pitch-card'>
        <div className='card-inner'>
          <div className='contents'>
            <h3>
              <i className='far fa-bullseye-arrow' />
              課題/解決策
            </h3>
            <p>
              {Util.newLineToBrTag(pitch.service_summary)}
            </p>
            <h3>
              <i className='far fa-toolbox' />
              現状の代替サービス
            </h3>
            <p>
              {Util.newLineToBrTag(pitch.service_superiority)}
            </p>
            <h3>
              <i className='far fa-bullhorn' />
              リーチ手段
            </h3>
            <p>
              {Util.newLineToBrTag(pitch.service_recognition)}
            </p>
          </div>
        </div>
      </div>

      <div className='pitch-card cover'>
        <div className='card-inner'>
          <h2>ABOUT TEAM</h2>
          <div className='main-info'>
            <div className='mb-4'>
              <img src={user.image} alt={user.full_name} className='rounded-circle thumb' />
              <h3>{user.full_name}</h3>
              {user.job_title && <p>{user.job_title}</p>}
            </div>
          </div>
        </div>
      </div>

      <div className='pitch-card'>
        <div className='card-inner'>
          <div className='contents'>
            <h3>
              <i className='far fa-address-card' />
              メンバープロフィール
            </h3>
            <p>
              {Util.newLineToBrTag(pitch.team_summary)}
            </p>
          </div>
        </div>
      </div>

      {pitch.team_episode && (
        <div className='pitch-card'>
          <div className='card-inner'>
            <div className='contents'>
              <h3>
                <i className='far fa-history' />
                メンバーの出会い
              </h3>
              <p>
                {Util.newLineToBrTag(pitch.team_episode)}
              </p>
            </div>
          </div>
        </div>
      )}

      {pitch.team_project && (
        <div className='pitch-card'>
          <div className='card-inner'>
            <div className='contents'>
              <h3>
                <i className='far fa-medal' />
                過去の共同プロジェクト
              </h3>
              <p>
                {Util.newLineToBrTag(pitch.team_project)}
              </p>
            </div>
          </div>
        </div>
      )}

      <div className='pitch-card'>
        <div className='card-inner'>
          <div className='contents'>
            <h3>
              <i className='far fa-coins' />
              資金調達について
            </h3>
            <p>
外部から出資を受けて
              {pitch.funded ? "いる" : "いない"}
            </p>
            {pitch.investment_summary && (
              <p>
                {Util.newLineToBrTag(pitch.investment_summary)}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className='pitch-card'>
        <div className='card-inner'>
          <div className='contents'>
            <h3>
              <i className='far fa-star' />
              メッセージの目的
            </h3>
            <p>
              {pitch.message_type}
            </p>
          </div>
        </div>
      </div>
    </Slider>
  );
}

PitchSlide.propTypes = {
  pitch: PropTypes.shape({
    funded: PropTypes.bool.isRequired,
    investment_summary: PropTypes.string,
    message_type: PropTypes.string.isRequired,
    service_category: PropTypes.string.isRequired,
    service_development_term: PropTypes.string.isRequired,
    service_name: PropTypes.string.isRequired,
    service_progress: PropTypes.string.isRequired,
    service_recognition: PropTypes.string.isRequired,
    service_summary: PropTypes.string.isRequired,
    service_superiority: PropTypes.string.isRequired,
    service_url: PropTypes.string,
    team_episode: PropTypes.string,
    team_project: PropTypes.string,
    team_summary: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired
  }).isRequired
};

export default PitchSlide;
